import React from 'react'

interface IProps {
    className?: string
    onClick?: any
    children?: any
    state?: boolean
}

const WizSwitchButton: React.FC<IProps> = ({className, onClick, children, state}) => {
    const buttonBackgroundColor = state
        ? 'bg-black hover:bg-font01 text-white'
        : 'border border-line01 hover:bg-bg_gray01'

    return (
        <button
            className={`px-[20px] py-[7px] text-body2 rounded-[5px] ${buttonBackgroundColor} ${className}`}
            onClick={onClick}>
            {children}
        </button>
    )
}

export default WizSwitchButton
